// src/layout/AdminLayout.tsx
import React from "react";
import styled from "styled-components";
import Sidebar from "./Sidebar";
import Header from "./Header";

const LayoutWrapper = styled.div`
  display: flex;
  height: 100vh;
  background-color: #f9fafb;
  width: 100%;
  overflow: hidden; /* ✅ 전체는 스크롤/밀림 금지 */
`;

const SidebarFixed = styled.div`
  width: 240px;
  flex: 0 0 240px; /* ✅ 폭 고정 + shrink 방지 */
  flex-shrink: 0;
`;

const ContentWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;

  min-width: 0; /* ✅ 핵심: 오른쪽 영역이 overflow 처리 가능해짐 */
`;

const MainContent = styled.main`
  flex: 1 1 auto;
  padding: 24px;

  min-width: 0; /* ✅ 핵심: 자식(테이블)이 길어도 여기서 처리 */
  overflow-y: auto;
  overflow-x: auto; /* ✅ 가로로 넘치면 MainContent에서만 스크롤 */
`;

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <LayoutWrapper>
      <SidebarFixed>
        <Sidebar />
      </SidebarFixed>

      <ContentWrapper>
        <Header />
        <MainContent>{children}</MainContent>
      </ContentWrapper>
    </LayoutWrapper>
  );
};

export default Layout;
